import { useState } from "react";
import { useSelector } from "react-redux";
import Edit2FillIcon from "remixicon-react/Edit2FillIcon";
import AddCircleFillIcon from "remixicon-react/AddCircleFillIcon";
import QAPopUp from "../Popup/QAPopUp";

const STATUS_STYLES: Record<string, string> = {
    PUBLISHED: "bg-green-100 text-green-800 border-green-200",
    ANSWERED: "bg-blue-100 text-blue-800 border-blue-200",
    UNANSWERED: "bg-amber-100 text-amber-800 border-amber-200",
    DISABLED: "bg-rose-100 text-rose-800 border-rose-200",
};

export const QAStatusPill = ({ value }: { value: string }) => (
    <span className={`inline-block whitespace-nowrap px-1.5 py-0.5 rounded text-[11px] font-medium border ${STATUS_STYLES[value] || "bg-gray-100 text-gray-700 border-gray-200"}`}>
        {value || "—"}
    </span>
);

const QAListItem = (props: any) => {
    const store: any = useSelector(s => s)
    const { user } = store.authStore
    const { data, selectedQuestionIds, setSelectedQuestionIds } = props
    const [qAPopupData, setQAPopupData] = useState({
        open: false,
        qid: ""
    });

    const handleClickEvent = (openPoupup: boolean, currentqid: any) => {
        setQAPopupData((qAPopupData) => ({
            ...qAPopupData,
            qid: currentqid,
            open: openPoupup
        }));
    };

    function formatDate(date: string): string {
        if (!date) return "—";
        const originalDate = new Date(date);
        if (isNaN(originalDate.getTime())) return "—";
        const year = originalDate.getUTCFullYear();
        const month = String(originalDate.getUTCMonth() + 1).padStart(2, '0');
        const day = String(originalDate.getUTCDate()).padStart(2, '0');
        const hours = String(originalDate.getUTCHours()).padStart(2, '0');
        const minutes = String(originalDate.getUTCMinutes()).padStart(2, '0');
        const seconds = String(originalDate.getUTCSeconds()).padStart(2, '0');
        const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
        return formattedDate;
    }

    const isSelected = (questionId: any) =>
        selectedQuestionIds.some((item: { questionId: any; }) => item.questionId === questionId);

    const handleQuestionSelect = (questionId: any, published: any) => {
        const existingIndex = selectedQuestionIds.findIndex((item: { questionId: any; }) => item.questionId === questionId);
        if (existingIndex !== -1) {
            // If the questionId is already selected, remove it from the array
            setSelectedQuestionIds((prevSelectedQuestionIds: any[]) =>
                prevSelectedQuestionIds.filter(item => item.questionId !== questionId)
            );
        } else {
            // If the questionId is not selected, add it to the array
            setSelectedQuestionIds((prevSelectedQuestionIds: any) =>
                [...prevSelectedQuestionIds, { questionId, published }]
            );
        }
    };

    if (!data.length) {
        return (
            <tr>
                <td colSpan={10} className="px-4 py-12 text-center text-xs text-gray-500">No questions found.</td>
            </tr>
        )
    }

    return (
        <>
            {
                qAPopupData.open &&
                <QAPopUp qAPopupData={qAPopupData} setQAPopupData={setQAPopupData} user={user} />
            }
            {data.map((_d: any) =>
                <tr key={_d.id} className='[&:nth-child(even)]:bg-[#f7f7f7]'>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">
                        {/* Controlled, so clearing the selection after publishing
                            also clears the boxes. */}
                        <input
                            type="checkbox"
                            name="selectedQuestion"
                            checked={isSelected(_d.id)}
                            onChange={() => handleQuestionSelect(_d.id, _d.status)}
                            className="h-4 w-4 cursor-pointer"
                        />
                    </td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] font-medium">{_d.id}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">{_d.productMsn || "—"}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">{_d.customerId || "—"}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">{_d.categoryName || "—"}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">{_d.questionText}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">
                        <QAStatusPill value={_d.status} />
                    </td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] whitespace-nowrap">{formatDate(_d.created)}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] whitespace-nowrap">{formatDate(_d.modified)}</td>
                    <td className="px-4 py-3">
                        {/* Two icons rather than one: the action differs by
                            status, which a single pencil would flatten. */}
                        <button
                            onClick={() => handleClickEvent(true, _d.id)}
                            className="text-blue-600 hover:text-blue-800 transition-colors"
                            title={_d.status === "ANSWERED" ? "Update answer" : "Add answer"}
                        >
                            {_d.status === "ANSWERED"
                                ? <Edit2FillIcon size={16} />
                                : <AddCircleFillIcon size={16} />}
                        </button>
                    </td>
                </tr>)}
        </>
    )
}

export default QAListItem
